export default __webpack_public_path__ + "static/media/element_64.738b6176.jpg";